import * as React from 'react';
import { getDeveloper } from '../../selectors/developerV2';
import { useSelector } from 'react-redux';
import { Avatar, useDeviceType } from '@cian/ui-kit';
import { RedesignIntroduction } from '../../components/Introduction/RedesignIntroduction';
import { Heading } from '../../components/Heading';
import { Ratings } from '../RatingsRedesigned';
import { ContactButtonsContainer } from '../ContactButtonsRedesigned';
import { BreadCrumbs } from '../BreadCrumbs';

import { introductionDisclaimerSelector } from '../../selectors';
import { Ticker } from '../../components/Ticker/Ticker';
import { PromoSlider } from '../../components/PromoSlider';

export const Introduction = () => {
  const { poster, logoUrl, name, templateSpecialPromo } = useSelector(getDeveloper);
  const introductionDisclaimer = useSelector(introductionDisclaimerSelector);

  const device = useDeviceType();

  const avatarSize = React.useMemo(() => (device === 'desktop' ? 80 : 60), [device]);

  const bannersList = templateSpecialPromo?.bannerList;

  return (
    <div>
      <RedesignIntroduction
        breadcrumbs={<BreadCrumbs />}
        backgroundSlider={bannersList?.length ? <PromoSlider testId="PromoSlider" banners={bannersList} /> : null}
        backgroundImage={!bannersList?.length && !!poster ? poster : undefined}
        title={<Heading name={name} />}
        logo={<Avatar src={logoUrl} size={avatarSize} type="builder" />}
        contacts={<ContactButtonsContainer />}
        rating={<Ratings />}
        disclaimer={introductionDisclaimer ? <Ticker text={introductionDisclaimer} /> : null}
      />
    </div>
  );
};
